import { Box, Button, Container, FormField, Header, Input, Link, Modal, SpaceBetween } from '@cloudscape-design/components';
import Calendar from "@cloudscape-design/components/calendar";
import { mdiCalendarArrowLeft, mdiCalendarArrowRight, mdiCalendarToday, mdiDeleteOutline, mdiWindowClose } from '@mdi/js';
import Icon from '@mdi/react';
import { addDays, format, parse } from 'date-fns';
import React, { useState } from 'react';
import { hideKeyboardGlobally, normalizeDate } from '../pages/commons/functions';
import { btnIcon } from '../resources/types';
interface DPModalProps {
  close?: boolean;
  clear?: boolean;
  today?: boolean;
  yearPrev?: boolean;
  yearNext?: boolean;
  tomorrow?: boolean;
  yesterday?: boolean;
  start?: Date;
  end?: Date;
  date?: string
  title?: string;
  subTitle?: string;
  disabledDates?: string[];
  width?: number;
  yearSelector?: boolean;
  readonly?: boolean;
  //onDismiss: () => void;
  onConfirm?: (selectedDate: string) => void;
}
const DPModal: React.FC<DPModalProps> = ({
  close = false,
  clear = true,
  today = false,
  tomorrow = false,
  yesterday = false,
  start = undefined,
  end = undefined,
  yearPrev = false,
  yearNext = false,
  yearSelector = false,
  date = "",
  title = 'Seleccione',
  subTitle = '',
  disabledDates = [],
  width = 200,
  readonly = false,
  onConfirm,
}) => {
  const [selectedDate, setSelectedDate] = useState<string>('');
  const [localDate, setLocalDate] = useState<string>(date || '');
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showYear, setShowYear] = useState<boolean>(false);
  const [reRender, setReRender] = useState(0);
  const handleDateChange = ({ detail }: { detail: { value: string } }) => {
    setSelectedDate(normalizeDate(detail.value));
    setLocalDate(normalizeDate(detail.value));
    onConfirm(normalizeDate(detail.value));
    date = detail.value
    hideKeyboardGlobally();
    onDismiss();
  };
  const handleMonthChange = ({ detail }: { detail: { value: string } }) => {
    const days = date && date !== "" ? date.substring(0, 2) : "01"
    const newDate = `${detail.value}-${days}`;
    setSelectedDate(normalizeDate(newDate));
    setLocalDate(normalizeDate(newDate));
    setReRender(prev => prev + 1); // Force re-render
    hideKeyboardGlobally();
    setShowYear(false);
  };

  const onDismiss = () => {
    setShowModal(false);
  }
  const dateClear = () => {
    setSelectedDate('')
    onConfirm('');
    onDismiss();
  }
  const mapDateStringsToDates = (dateStrings: string[]): Date[] => {
    return dateStrings.map(item =>
      // The parse function requires the date string, the format, and a reference date
      parse(item, "dd-MM-yyyy", new Date())
    );
  };

  // This is the array (list of Date objects) you will check against:
  const disabledDatesArray: Date[] = mapDateStringsToDates(disabledDates);

  const isSameDay = (date1: Date, date2: Date): boolean => {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  };
  const isDateInDisabledList = (d: Date): boolean => {
    // Use .some() to check if ANY disabledDate in the array matches the input date (d)
    return disabledDatesArray.some(disabledDate => isSameDay(d, disabledDate));
  };
  const dateToday = () => {
    const formatted = format(new Date(), "dd-MM-yyyy");
    setSelectedDate(formatted)
    onConfirm(formatted);
    onDismiss();
  }
  const dateYesterday = () => {
    const formatted = format(addDays(new Date(), -1), "dd-MM-yyyy");
    setSelectedDate(formatted)
    onConfirm(formatted);
    onDismiss();
  }
  const dateTomorrow = () => {
    const formatted = format(addDays(new Date(), 1), "dd-MM-yyyy");
    setSelectedDate(formatted)
    onConfirm(formatted);
    onDismiss();
  }

  const normalizedStart = start ? new Date(start.getFullYear(), start.getMonth(), start.getDate()) : undefined;
  const normalizedEnd = end ? new Date(end.getFullYear(), end.getMonth(), end.getDate()) : undefined;
  //const normalizedDate = end ? new Date(date.getFullYear(), date.getMonth(), date.getDate()) : undefined;
  const isDateInRange = (date: Date) => {
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    if (normalizedStart && normalizedEnd) return d >= normalizedStart && d <= normalizedEnd;
    if (normalizedStart) return d >= normalizedStart;
    if (normalizedEnd) return d <= normalizedEnd;
    return true;
  };


  return (
    <>
      <div onClick={(e) => {
        if (readonly) return;
        e.preventDefault();
        e.stopPropagation();
        setShowModal(true)
      }} style={{ cursor: 'pointer', maxWidth: width }}>
        <Input value={date} onChange={() => { }} placeholder='Seleccionar fecha'
          inputMode="none"
          readOnly
          style={{
            root: {
              borderColor: {
                readonly: "#8c8c94",
                focus: "#8c8c94"
              }
            }
          }}
        />
      </div>
      <Modal
        visible={showModal}
        onDismiss={onDismiss}
        size="small"
        header={<Header variant="h1">{title}</Header>}
        footer={
          <div className='containerFooterButtons'>
            {close && (
              <div><Button style={{ root: btnIcon }} onClick={onDismiss}><Icon path={mdiWindowClose} size={1} /></Button></div>
            )}
            {yesterday && (
              <div><Button style={{ root: btnIcon }} onClick={dateYesterday}><Icon path={mdiCalendarArrowLeft} size={1} /></Button></div>
            )}
            {today && (
              <div><Button style={{ root: btnIcon }} onClick={dateToday}><Icon path={mdiCalendarToday} size={1} /></Button></div>
            )}
            {tomorrow && (
              <div><Button style={{ root: btnIcon }} onClick={dateTomorrow}><Icon path={mdiCalendarArrowRight} size={1} /></Button></div>
            )}
            {clear && (
              <div><Button style={{ root: btnIcon }} onClick={dateClear}><Icon path={mdiDeleteOutline} size={1} /></Button></div>
            )}
          </div>
        }
      >

        <FormField label={subTitle} stretch>
          <Container>
            <SpaceBetween size="xs">

              {showYear && (
                <Calendar
                  onChange={handleMonthChange}
                  value={normalizeDate(localDate)}
                  granularity="month"
                  isDateEnabled={(date) => {
                    return isDateInRange(date) && !isDateInDisabledList(date)

                  }}
                />
              )}
              {!showYear && (
                <SpaceBetween direction='vertical' size='xs'>
                  <Box textAlign='center'>
                    <Link onClick={() => setShowYear(true)}>Mes/Año</Link>
                  </Box>
                  <Calendar
                    key={`reRender${reRender}`}
                    value={normalizeDate(localDate)}

                    onChange={handleDateChange}
                    locale="es-CL"
                    startOfWeek={1}
                    isDateEnabled={(date) => {
                      return isDateInRange(date) && !isDateInDisabledList(date)

                    }}
                  />
                </SpaceBetween>
              )}
            </SpaceBetween>
          </Container>
        </FormField>
      </Modal >
    </>
  );
};

export default DPModal;